import Page, { getProps } from '@/modules/media/press'

export const getServerSideProps = getProps

export default Page
